import { useAppBar } from "@/appBar/useAppBar";
import { usePortfolio } from "@/portfolio/portfolioDomain";
import { useDispatch, useRootStore, useTranslation } from "@/stores/RootStoreContext";
import { observer } from "mobx-react";
import { useEffect, useMemo } from "react";
import { PortfolioSearchView } from "./portfolioSearchComponents";
import { initPortfolioSearchPage, PortfolioSearchContext } from "./portfolioSearchDomain";

export const PortfolioSearchPage = observer(() => {
  const { portfolioSearch, messageStore } = useRootStore();
  const dispatch = useDispatch();
  const { t, lang } = useTranslation();
  const { portfolio, header } = usePortfolio({ portfolioType: "all-companies" });
  const appBar = useAppBar({
    isPortfolioPage: true,
    portfolioHeader: header,
    selectedPortfolioOption: portfolio,
  });
  const context: PortfolioSearchContext = useMemo(
    () => ({ portfolio, appBar, alertStore: messageStore, dispatch, t, language: lang }),
    [portfolio, appBar, messageStore, dispatch, t, lang],
  );

  useEffect(() => {
    dispatch(initPortfolioSearchPage());
  }, [dispatch]);

  return <PortfolioSearchView state={portfolioSearch} context={context} />;
});
